// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2jWZx","label":"SetPasswdForm_label__7ZlBP"};